"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _text_input = require("../../text_input");
var _select_input = require("../../select_input");
var _ValidateDateOfBirth = require("../../../../utils/ValidateDateOfBirth");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var DateOfBirthInputV2 = function DateOfBirthInputV2(_ref) {
  var register = _ref.register,
    errors = _ref.errors,
    defaultValue = _ref.defaultValue,
    setValue = _ref.setValue,
    clearError = _ref.clearError,
    dateValue = _ref.dateValue;
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    day = _useState2[0],
    setDay = _useState2[1];
  var _useState3 = (0, _react.useState)(defaultValue),
    _useState4 = _slicedToArray(_useState3, 2),
    month = _useState4[0],
    setMonth = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    year = _useState6[0],
    setYear = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isDOBValid = _useState8[0],
    setIsDOBValid = _useState8[1];
  var monthsList = [{
    option: 'Jan',
    value: '01'
  }, {
    option: 'Feb',
    value: '02'
  }, {
    option: 'Mar',
    value: '03'
  }, {
    option: 'Apr',
    value: '04'
  }, {
    option: 'May',
    value: '05'
  }, {
    option: 'Jun',
    value: '06'
  }, {
    option: 'Jul',
    value: '07'
  }, {
    option: 'Aug',
    value: '08'
  }, {
    option: 'Sep',
    value: '09'
  }, {
    option: 'Oct',
    value: '10'
  }, {
    option: 'Nov',
    value: '11'
  }, {
    option: 'Dec',
    value: '12'
  }];
  var handleDateInput = function handleDateInput(e) {
    if (!errors['day']) {
      setDay(('0' + e.target.value).slice(-2));
    } else {
      setDay('');
    }
  };
  var handleMonthInput = function handleMonthInput(itemObject) {
    if (itemObject.value) {
      setMonth(itemObject.value);
      setValue('month', itemObject.value);
      clearError('month');
    } else {
      setMonth('');
      setValue('month', '');
    }
  };
  var handleYearInput = function handleYearInput(e) {
    if (!errors['year']) {
      setYear(e.target.value);
    } else {
      setYear('');
    }
  };
  (0, _react.useEffect)(function () {
    if (day && month && year && !errors['day'] && !errors['month'] && !errors['year']) {
      var validateDOB = (0, _ValidateDateOfBirth.ValidateDateOfBirth)("".concat(day, "/").concat(month, "/").concat(year));
      setIsDOBValid(validateDOB);
      if (validateDOB) {
        setValue('date', "".concat(day, "/").concat(month, "/").concat(year));
      } else {
        setValue('date', '');
      }
    }
  }, [day, month, year]);
  var clearValues = function clearValues() {
    setValue('month', '');
    clearError('month');
  };
  (0, _react.useEffect)(function () {
    clearValues();
  }, []);
  (0, _react.useEffect)(function () {
    register({
      name: 'month'
    }, {
      required: 'Missing Birth Month'
    });
    clearValues();
    register({
      name: 'date'
    }, {
      required: 'Missing date of Birth'
    });
  }, [register]);
  (0, _react.useEffect)(function () {
    if (dateValue) {
      var _dateValue$split = dateValue.split('/'),
        _dateValue$split2 = _slicedToArray(_dateValue$split, 3),
        _day = _dateValue$split2[0],
        _month = _dateValue$split2[1],
        _year = _dateValue$split2[2];
      setDay(_day);
      setYear(_year);
      setMonth(_month);
      setValue('month', _month);
    }
  }, [dateValue]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-row mr-16"
  }, /*#__PURE__*/_react["default"].createElement(_text_input.TextInput, {
    cypressClass: "day",
    type: "tel",
    maxLength: 2,
    onChange: handleDateInput,
    label: "Birth Day",
    name: "day",
    error: errors['day'] || day && typeof isDOBValid === 'string' ? true : false,
    helperText: day && typeof isDOBValid === 'string' ? isDOBValid : errors['day'] ? errors.day.message : '',
    register: register({
      required: 'Missing Birth Day',
      pattern: {
        value: /^(0?[1-9]|[1-2][0-9]|3[0-1])$/,
        message: 'Please enter a valid Date'
      }
    })
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-row mr-16"
  }, /*#__PURE__*/_react["default"].createElement(_select_input.SelectInput, {
    cypressClass: "month",
    onChange: handleMonthInput,
    optionsList: monthsList,
    label: "Birth Month",
    error: errors['month'] ? true : false,
    helperText: errors['month'] ? errors.month.message : '',
    value: month
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/_react["default"].createElement(_text_input.TextInput, {
    cypressClass: "year",
    type: "tel",
    maxLength: 4,
    onChange: handleYearInput,
    label: "Birth Year",
    name: "year",
    error: errors['year'] ? true : false,
    helperText: errors['year'] ? errors.year.message : '',
    register: register({
      required: 'Missing Birth Year',
      pattern: {
        value: /^(19[2-9][0-9]|20[0-1][0-9]|202[0-8])$/,
        message: 'Please enter a valid year'
      }
    })
  })));
};
DateOfBirthInputV2.defaultProps = {
  errors: {},
  register: function register() {},
  setValue: function setValue() {},
  clearError: function clearError() {},
  defaultValue: null
};
DateOfBirthInputV2.propTypes = {
  /**
   * Object containing the errors from this input field.
   */
  errors: _propTypes["default"].object,
  /**
   * A function that gets passed for the useForm hook from react-hook-form to register an input
   *
   */
  register: _propTypes["default"].func.isRequired,
  setValue: _propTypes["default"].func.isRequired,
  clearError: _propTypes["default"].func.isRequired,
  defaultValue: _propTypes["default"].string
};
var _default = exports["default"] = DateOfBirthInputV2;